import React from 'react';

import { ContactBookDetails } from 'core/lib';

export const ContactBookDetailsContext = React.createContext<ContactBookDetails | Partial<ContactBookDetails> | null>(
  null
);
